/* eslint-disable no-unused-expressions */

import 'moment/locale/pt-br'

import { FIELD_TYPE, REQUIRED_FIELD_MESSAGES } from '../../utils/formHelper'
import React, { Component } from 'react'

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import Box from '@mui/material/Box'
import Grid from './GridLegacyCompat';import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import moment from 'moment'
import uuid from 'react-uuid'

// API NOTE (post MUI v9):
// `ranged` é usado por 5 consumidores (BatchForm + Batch + D0 + D0IATF +
// D0AfterResync) para o caso "Data dos Partos" / "Data do parto" (intervalo
// começo-fim). O range picker real (@mui/x-date-pickers-pro DateRangePicker)
// é Pro/pago, então usamos o pattern padrão da comunidade free: dois single
// pickers lado-a-lado (De / Até) dentro do mesmo LocalizationProvider.
//
// Contrato preservado:
//   - initialValues={[start, end]}  → valores iniciais dos 2 pickers
//   - onChange(values)              → values é array [start, end] ou single
//                                     moment (no fluxo write a partir de
//                                     único picker). `datefieldRangedDefault
//                                     OnChange` já lida com os 2 formatos.
//   - label                         → prefixo dos 2 pickers (sufixos "(De)"
//                                     e "(Até)")
//   - disabled, error, helperText   → aplicam a ambos

function datefieldDefaultOnChange(
  field,
  message = REQUIRED_FIELD_MESSAGES.DEFAULT
) {
  return (value) => {
    this.setState({
      [field]: value,
      [`${field}_error`]:
        this.missingRequiredFieldChecker(field, value, FIELD_TYPE.DATE) &&
        message,
    })
  }
}

function hoursfieldDefaultOnChange(
  field,
  message = REQUIRED_FIELD_MESSAGES.DEFAULT
) {
  return (value) => {
    this.setState({
      [field]: value,
      [`${field}_error`]:
        this.missingRequiredFieldChecker(field, value, FIELD_TYPE.DATE) &&
        message,
    })
  }
}

function datefieldRangedDefaultOnChange(
  field,
  message = REQUIRED_FIELD_MESSAGES.DEFAULT
) {
  return (values) => {
    if (values && values.length > 2) {
      this.setState({
        [`${field}_error`]:
          this.missingRequiredFieldChecker(
            field,
            values,
            FIELD_TYPE.DATE_RANGE
          ) && message,
      })
    } else if (values && values.length === 2) {
      this.setState({
        [`${field}_start`]: values[0],
        [`${field}_end`]: values[1],
        [`${field}_error`]:
          this.missingRequiredFieldChecker(
            field,
            values,
            FIELD_TYPE.DATE_RANGE
          ) && message,
      })
    } else {
      this.setState({
        [`${field}_start`]: values,
        [`${field}_end`]: values,
        [`${field}_error`]:
          this.missingRequiredFieldChecker(field, values, FIELD_TYPE.DATE) &&
          message,
      })
    }
  }
}

class DateField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      id: props.id || uuid(),
    }
    this.onChange = this.onChange.bind(this)
    this.onKeyDown = this.onKeyDown.bind(this)
    this.onFocus = this.onFocus.bind(this)
    this.onBlur = this.onBlur.bind(this)

    moment.locale('pt-br')
  }

  onChange(value) {
    if (this.props.onChange) {
      let v = value
      if (v != null && v.isValid && v.isValid()) {
        v = v.clone().startOf('day')
      }
      this.props.onChange(v)
    }
  }

  onKeyDown(e) {
    if (this.props.onKeyDown) {
      this.props.onKeyDown(e)
    }
  }

  onFocus(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e)
    }
  }

  onBlur(e) {
    if (this.props.onBlur) {
      this.props.onBlur(e)
    }
  }

  // Coerção: qualquer valor → moment válido ou null.
  // MUI x-date-pickers v9 + AdapterMoment exige moment object como value
  // (precisa .isValid() etc). Aceita também Date nativo e string ISO de
  // consumidores legados pra evitar crash "value.isValid is not a function".
  toMoment(raw) {
    if (raw == null) return null
    if (moment.isMoment(raw)) return raw
    const m = moment(raw)
    return m.isValid() ? m : null
  }

  // Slot props comuns aos modos single e ranged. Extraído pra evitar
  // duplicação entre os 2 pickers do modo ranged.
  buildSlotProps(idSuffix = '') {
    return {
      textField: {
        id: idSuffix ? `${this.state.id}_${idSuffix}` : this.state.id,
        variant: 'outlined',
        size: 'small',
        autoComplete: 'off',
        error: this.props.error,
        helperText: this.props.helperText,
        onFocus: this.onFocus,
        onBlur: this.onBlur,
        onKeyDown: this.onKeyDown,
        slotProps: {
          htmlInput: { tabIndex: this.props.tabIndex },
          input: { style: { width: '100%' } },
        },
        style: {
          marginTop: '0',
          display: 'flex',
          justifyContent: 'space-evenly',
        },
      },
      openPickerButton: {
        'aria-label': 'Alterar',
        tabIndex: this.props.tabIndex,
        onFocus: this.onFocus,
        onClickCapture: this.props.onClickCaptureButton,
      },
      actionBar: {
        actions: ['cancel', 'accept'],
      },
    }
  }

  renderRanged() {
    // Origem dos valores: value (array) tem prioridade, depois initialValues.
    const arr = Array.isArray(this.props.value)
      ? this.props.value
      : Array.isArray(this.props.initialValues)
      ? this.props.initialValues
      : []
    const start = this.toMoment(arr[0])
    const end = this.toMoment(arr[1])

    const fire = (newStart, newEnd) => {
      if (this.props.onChange) {
        const s = newStart && newStart.isValid && newStart.isValid()
          ? newStart.clone().startOf('day')
          : newStart
        const e = newEnd && newEnd.isValid && newEnd.isValid()
          ? newEnd.clone().startOf('day')
          : newEnd
        this.props.onChange([s, e])
      }
    }

    const baseLabel = this.props.label || ''
    const localeText = {
      cancelButtonLabel: 'CANCELAR',
      okButtonLabel: 'Selecionar',
    }

    const ranged = (
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
        <Box
          sx={{
            display: 'flex',
            gap: 1,
            flexWrap: 'wrap',
            '& > *': { flex: '1 1 140px', minWidth: 0 },
          }}
        >
          <DatePicker
            label={baseLabel ? `${baseLabel} (De)` : 'De'}
            format="DD/MM/YYYY"
            value={start}
            onChange={(v) => fire(v, end)}
            disabled={this.props.disabled}
            slotProps={this.buildSlotProps('start')}
            localeText={localeText}
          />
          <DatePicker
            label={baseLabel ? `${baseLabel} (Até)` : 'Até'}
            format="DD/MM/YYYY"
            value={end}
            onChange={(v) => fire(start, v)}
            disabled={this.props.disabled}
            slotProps={this.buildSlotProps('end')}
            localeText={localeText}
          />
        </Box>
      </LocalizationProvider>
    )

    if (this.props.withGrid) {
      return <Grid item xs={this.props.withGrid}>{ranged}</Grid>
    }
    return ranged
  }

  render() {
    if (this.props.ranged) {
      return this.renderRanged()
    }

    const safeValue = this.toMoment(this.props.value)

    const datefield = (
      <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="pt-br">
        <DatePicker
          label={this.props.label}
          format="DD/MM/YYYY"
          value={safeValue}
          onChange={this.onChange}
          disabled={this.props.disabled}
          slotProps={this.buildSlotProps()}
          localeText={{
            cancelButtonLabel: 'CANCELAR',
            okButtonLabel: 'Selecionar',
          }}
        />
      </LocalizationProvider>
    )
    if (this.props.withGrid) {
      return (
        <Grid item xs={this.props.withGrid}>
          {datefield}
        </Grid>
      )
    }
    return datefield
  }
}

export {
  datefieldDefaultOnChange,
  datefieldRangedDefaultOnChange,
  hoursfieldDefaultOnChange,
}

export default DateField
